import { useParams } from "react-router-dom";
import FormCodSistema from "./formulario";
// import FormEmpresa from "./components/formulario";

export function CodigiodoSistemaIncluir() {
  const idcodigo = useParams();
  return (
    <>
      <div className="container-fluid mt-2">
        <FormCodSistema idcodigo={idcodigo.id} acao="Novo" />
      </div>
    </>
  );
}
